import React, { useState } from 'react';
import UsuarioList from '../components/UsuarioList';
import UsuarioForm from '../components/UsuarioForm';
import { Container, Typography, Box, Button } from '@mui/material';
import AddIcon from '@mui/icons-material/Add';
import { actionButtonSx, pageTitleSx } from '../styles/uiTokens';

function UsuariosPage() {
  const [refreshList, setRefreshList] = useState(false);
  const [editingUsuario, setEditingUsuario] = useState(null);
  const [linkingUsuario, setLinkingUsuario] = useState(null);
  const [showForm, setShowForm] = useState(false);

  const handleUsuarioAdded = () => {
    setRefreshList(prev => !prev);
    setEditingUsuario(null);
    setLinkingUsuario(null);
    setShowForm(false);
  };

  const handleEditUsuario = (usuario) => {
    setEditingUsuario(usuario);
    setLinkingUsuario(null);
    setShowForm(true);
  };

  const handleLinkUsuario = (usuario) => {
    setEditingUsuario(null);
    setLinkingUsuario(usuario);
    setShowForm(true);
  };

  const handleCancelEditUsuario = () => {
    setEditingUsuario(null);
    setLinkingUsuario(null);
    setShowForm(false);
  };

  const handleUsuarioDeleted = () => {
    setRefreshList(prev => !prev);
  };

  const handleShowForm = () => {
    setEditingUsuario(null);
    setLinkingUsuario(null);
    setShowForm(true);
  };

  return (
    <Container sx={{ mt: 4 }}>
      <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 2 }}>
        <Typography variant="h4" gutterBottom sx={pageTitleSx}>
          Gerenciar Usuários
        </Typography>
        {!showForm && (
          <Button
            variant="contained"
            startIcon={<AddIcon />}
            onClick={handleShowForm}
            sx={actionButtonSx}
          >
            Adicionar Usuário
          </Button>
        )}
      </Box>

      {showForm && (
        <UsuarioForm
          onUsuarioAdded={handleUsuarioAdded}
          isLinkMode={!!linkingUsuario}
          initialData={linkingUsuario || editingUsuario}
          onCancelEdit={handleCancelEditUsuario}
        />
      )}

      {!showForm && (
        <UsuarioList
          refresh={refreshList}
          onEdit={handleEditUsuario}
          onLink={handleLinkUsuario}
          onUsuarioDeleted={handleUsuarioDeleted}
        />
      )}
    </Container>
  );
}

export default UsuariosPage;
